import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Seo } from "@/components/Seo";

const Landing = lazy(() => import("@/pages/Landing"));
const AdminLeads = lazy(() => import("@/pages/AdminLeads"));
const PaymentSuccess = lazy(() => import("@/pages/PaymentSuccess"));
const PaymentCancel = lazy(() => import("@/pages/PaymentCancel"));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
const TermsOfService = lazy(() => import("@/pages/TermsOfService"));
const AdGallery = lazy(() => import("@/pages/AdGallery"));

const D = "https://zerodealership.com";
const Fallback = <div className="min-h-screen bg-black" />;
const Lazy = ({ children }) => <Suspense fallback={Fallback}>{children}</Suspense>;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster theme="dark" richColors position="top-center" />
        <Routes>
          <Route path="/" element={<Lazy><Landing /></Lazy>} />
          <Route
            path="/admin"
            element={
              <>
                <Seo title="Lead Manager | Zero Dealership" description="Internal pipeline dashboard: every incoming deal-audit request, searchable and filterable by stage." canonical={`${D}/admin`} noindex />
                <Lazy><AdminLeads /></Lazy>
              </>
            }
          />
          <Route
            path="/payment/success"
            element={
              <>
                <Seo title="Retainer Confirmed | Zero Dealership" description="Your Zero Dealership concierge retainer payment confirmation." noindex />
                <Lazy><PaymentSuccess /></Lazy>
              </>
            }
          />
          <Route
            path="/payment/cancel"
            element={
              <>
                <Seo title="Checkout Cancelled | Zero Dealership" description="Your Zero Dealership checkout was cancelled — no charge was made." noindex />
                <Lazy><PaymentCancel /></Lazy>
              </>
            }
          />
          <Route
            path="/privacy"
            element={
              <>
                <Seo title="Privacy Policy | Zero Dealership" description="How Zero Dealership collects, uses, and protects your information — lead form data, Stripe payments, ad measurement, and your rights." canonical={`${D}/privacy`} />
                <Lazy><PrivacyPolicy /></Lazy>
              </>
            }
          />
          <Route
            path="/terms"
            element={
              <>
                <Seo title="Terms of Service | Zero Dealership" description="Terms for Zero Dealership's car-buying concierge: the flat retainer, the written-baseline savings guarantee, independence, and liability." canonical={`${D}/terms`} />
                <Lazy><TermsOfService /></Lazy>
              </>
            }
          />
          <Route
            path="/ads"
            element={
              <>
                <Seo title="Ad Creative Library | Zero Dealership" description="Zero Dealership advertising creative library." noindex />
                <Lazy><AdGallery /></Lazy>
              </>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
